import React, { useEffect } from "react";
import ReportSection from "../../components/Food_Repot/ReportSection";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useGetShopSuggestionsByVendorIdQuery } from "../../features/shop/shopApiSlice";

const ServicesuggestionSection = () => {
  const { id } = useParams();
  const [suggestdata, setSuggestdata] = useState();

  const { data: suggestionsRes } = useGetShopSuggestionsByVendorIdQuery(id, { skip: !id });

  useEffect(() => {
    if (suggestionsRes?.success) {
      setSuggestdata(suggestionsRes?.data[0]?.suggestions);
    }
  }, [suggestionsRes]);

  return (
    <>
      <ReportSection title="Suggestions" suggestdata={suggestdata} id={id} />
    </>
  );
};

export default ServicesuggestionSection;
